import { SegmentTrackEvents } from 'utils/segment/constants';
import { fetchDocumentsToBeUploaded } from './apis';

export const isEWPlan = (planId: string) => {
    try {
        return planId?.includes('_ew');
    } catch {
        return false;
    }
};

export const getLabels = (partnerId: string) => {
    if (partnerId.toLowerCase() === 'xiaomi') {
        return {
            headerText: 'Upload Documents',
        };
    }
    return {
        headerText: 'Upload Purchase Documents',
    };
};

export interface IDocumentList {
    documentText: string;
    documentHelperText: string;
    id: string;
    mandatory: boolean;
    name: string;
    url: string;
    type: string;

    segmentEvent: string;
    warningNote?: string;
}

export const fetchDocumentList = async (
    partnerId: string,
    planId: string,
    programId: string
): Promise<IDocumentList[]> => {
    const { statusCode, data, errorMessage } = await fetchDocumentsToBeUploaded(
        partnerId,
        planId,
        programId
    );
    const reHydratedData: IDocumentList[] = data.map((docs) => ({
        ...docs,
        name: '',
        url: '',
        documentText: docs.document_text,
        documentHelperText: docs.document_helper_text,
        segmentEvent: docs.segment_event,
        warningNote: docs.warning_note,
    }));
    if (statusCode === 200) {
        return reHydratedData;
    }
    console.error(errorMessage);
    return [];
};

export const getDocumentList = (
    partnerId: string,
    category: string,
    ew: boolean
): IDocumentList[] => {
    if (partnerId.toLowerCase() === 'xiaomi') {
        // ew
        if (ew) {
            // television
            if (category.toLowerCase() === 'television') {
                return [
                    {
                        id: 'invoice',
                        documentText: 'Upload Invoice',
                        documentHelperText: 'Upload Invoice',
                        name: '',
                        url: '',
                        mandatory: true,
                        segmentEvent: SegmentTrackEvents.TAP_CTA_UPLOAD_INVOICE,
                        type: 'INVOICE',
                    },
                ];
            }
            // mobile
            return [
                {
                    id: 'invoice',
                    documentText: 'Upload Service Order',
                    documentHelperText: 'Upload Service Order',
                    name: '',
                    url: '',
                    mandatory: true,
                    segmentEvent: SegmentTrackEvents.TAP_CTA_UPLOAD_INVOICE,
                    type: 'INVOICE',
                },
                {
                    id: 'imei',
                    documentText: 'Upload Service Record',
                    documentHelperText: 'Upload Service Record',
                    name: '',
                    url: '',
                    mandatory: true,
                    segmentEvent: SegmentTrackEvents.TAP_CTA_UPLOAD_BOX_IMAGE,
                    type: 'IMEI_IMAGE',
                },
            ];
        }
    }

    // default
    // Oppo all models
    return [
        {
            id: 'invoice',
            documentText: 'Upload Invoice',
            documentHelperText: 'Upload file',
            mandatory: true,
            name: '',
            url: '',
            segmentEvent: SegmentTrackEvents.TAP_CTA_UPLOAD_INVOICE,
            warningNote: 'Date of invoice must be today',
            type: 'INVOICE',
        },
        {
            id: 'imei',
            documentText: 'Upload Box image with IMEI visible',
            documentHelperText: 'Upload file',
            name: '',
            url: '',
            mandatory: true,
            segmentEvent: SegmentTrackEvents.TAP_CTA_UPLOAD_BOX_IMAGE,
            type: 'IMEI_IMAGE',
        },
    ];
};

export function findDocumentById(documents: IDocumentList[], id: string) {
    return documents.find((doc: IDocumentList) => doc.id === id);
}

export const getDocumentUploaderStatusLoaders = (
    partnerId: string,
    category: string,
    ew: boolean
) => {
    return getDocumentList(partnerId, category, ew).map((doc) => doc.id);
};
